import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-man-power-location',
  templateUrl: './man-power-location.component.html',
  styleUrls: ['./man-power-location.component.css']
})
export class ManPowerLocationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
